<template>

<com-item name="hindex.bias" :size="size" :is-empty="!active" :loading="loading" title="Index Stability">

	<template v-slot:about>

		<p>See the index stability for {{ your }} h-index and everyone else.</p>

	</template>

	<template v-slot:stats>
	
		<app-visualisation-bars :data="graph" v-if="active" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			graph: {
				datasets: [
					{ type: 'bar', dataType: 'percent', data: [], backgroundColor: '#4881bb', tooltip: '{{value}} of users with same H-index <small>{{x.label}}</small>' },
					{ type: 'bar', dataType: 'percent', data: [], backgroundColor: '#9cbad9', tooltip: '{{value}} of all users <small>{{x.label}}</small>' },
				],
				axis: {
					x: {
						labels: [{
							label: 'Flash Entries',
						}, {
							label: 'Rotating Core',
						}, {
							label: 'Mixed Tenure',
						}, {
							label: 'Reliable Returners',
						}, {
							label: 'Enduring Core',
						}, {
							label: 'Evergreen Pillars'
						}]
					},
					y: {
						min: 10,
						points: 10
					}
				}
			}
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		active: function() {

			return this.$_.keys(this.data).length && !this.loading

		},

		data: function() {

			return this.$store.getters['page/insights/hindex/bias']

		}

	},

	watch: {

		data: function() {

			this.visualise()

		}

	},

	created: function() {
	
		this.visualise()

	},

	methods: {

		visualise: function() {

			if (this.$_.keys(this.data).length) {

				this.graph.datasets[0].data = []
				this.graph.datasets[1].data = []

				var value = this.$store.getters['page/insights/hindex/overview'].bias
				var highlight = false

				if (value < 150) highlight = 0
				else if (value < 240) highlight = 1
				else if (value < 340) highlight = 2
				else if (value < 440) highlight = 3
				else if (value < 590) highlight = 4
				else highlight = 5

				this.graph.datasets[0].highlight = highlight

				for (var i = 0; i <= 5; i++) {

					if (this.data[i]) {

						this.graph.datasets[0].data.push(this.data[i].own)
						this.graph.datasets[1].data.push(this.data[i].all)

					} else {

						this.graph.datasets[0].data.push(0)
						this.graph.datasets[1].data.push(0)

					}

				}

			}

		}
		
	}

}

</script>

<style scoped>

</style>